import { graphql } from "generated/gql";

export const updatePlantMaterialsDocument = graphql(/* GraphQL */ `
  mutation UpdatePlantMaterials($ids: [ID!]!, $input: PlantMaterialUpdates!) {
    updatePlantMaterials(ids: $ids, input: $input) {
      __typename
      success
      errors {
        message
      }
      plantMaterials {
        id
      }
    }
  }
`);
